<template>
  <Form
    :action-type="actionType"
    :subtitle="subtitle"
    :disabled="wasDisabled"
    :fallback-link="fallbackLink"
    :form-body="form"
    :show-preloader="isLoadingNow"
    @on-submit="submit"
    @on-edit="setEditMode(true)"
    @on-cancel="setEditMode(false)"
  >
    <template slot="fields">
      <div class="row">
        <div class="col-lg-12">
          <div
            v-for="(value, key, index) in formsFields.client.labels"
            :key="index"
            class="col-lg-6 form-group"
          >
            <fieldset>
              <label>
                {{ value }}
                <span
                  v-if="isRequiredField(validationSchemas.client[key])"
                  class="field__label_required"
                  >*</span
                >
              </label>
              <input
                class="form-control"
                :name="key"
                :maxlength="formsFields.client.maxLength[key]"
                placeholder="Отсутствует"
                :disabled="actionType === 'read'"
                v-model.trim="form.client[key]"
              />
            </fieldset>
          </div>
        </div>
      </div>
      <Sublist subtitle="Реквизиты">
        <template slot="fields">
          <div class="row">
            <div class="col-lg-12">
              <div
                v-for="(value, key, index) in formsFields.requisites.labels"
                :key="index"
                class="col-lg-6 form-group"
              >
                <fieldset>
                  <label>
                    {{ value }}
                    <span
                      v-if="isRequiredField(validationSchemas.requisites[key])"
                      class="field__label_required"
                      >*</span
                    >
                  </label>
                  <input
                    class="form-control"
                    placeholder="Отсутствует"
                    :name="key"
                    :maxlength="formsFields.requisites.maxLength[key]"
                    :disabled="actionType === 'read'"
                    v-model.trim="form.requisites[key]"
                  />
                </fieldset>
              </div>
            </div>
          </div>
        </template>
      </Sublist>
    </template>
  </Form>
</template>

<script>
import { validationMixin } from "vuelidate";
import validationSchemas from "@/business/validation-schemas";
import { clientService } from "@/business/api-services";

import Sublist from "@/_shared/features/form/Sublist";
import Form from "@/_shared/widgets/Form";

import { useForm, useNotification } from "@/_shared/mixins";
import { formsFields } from "@/business/constants";

import { objectHelper } from "@/_shared/utils";
const { createFromKeys } = objectHelper;
export default {
  mixins: [
    validationMixin,
    useForm,
    useNotification,
  ],
  components: {
    Form,
    Sublist,
  },
  data() {
    return {
      formsFields,
      validationSchemas,
      fallbackLink: "/clients",
      entityName: {
        readonly: "Клиент",
        modify: "клиента",
      },
      form: {
        client: createFromKeys(formsFields.client.labels),
        requisites: createFromKeys(formsFields.requisites.labels),
      },
    };
  },
  validations() {
    return {
      form: {
        client: validationSchemas.client,
        requisites: validationSchemas.requisites,
      },
    };
  },
  created() {
    const addingFields = {
      client: createFromKeys(this.formsFields.client.labels),
      requisites: createFromKeys(this.formsFields.requisites.labels),
    };
    this.setFormFields(addingFields, clientService.get);
  },
  methods: {
    async submit() {
      const callback = async () => (
        await clientService[this.actionType](this.form)
        .catch((error) => {
          throw new Error(error.message);
        })
      );
      await this.sendForm(callback);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/business/pages/ClientForm.vue